<template>
    <div>
        <div class="offer-header">
            <div class="page-title">
                <h4> {{$t('txt.creeazaOferta')}} </h4>
            </div>
            <div class="action-button-group">
              <div class="preview-template-button action-button" :class="{'action-button-active': action_button_state == 1}">
                  <button type="button" @click="showModal()">
                      <i class="far fa-eye"></i>
                  </button>
                  <div class="teardrop-text">
                    <span> {{$t('placeholder.veziOferta')}} </span>
                  </div>
              </div>
                <div class="preview-products-list action-button" :class="{'action-button-active': action_button_state == 2}">
                  <button type="button" @click="toggleSlideOut('products')" v-shortkey="['alt', '2']" @shortkey="toggleSlideOut('products')">
                      <i class="fas fa-th"></i>
                  </button>
                  <div class="teardrop-text">
                    <span> Adauga produse </span>
                  </div>
              </div>
              <div class="preview-template-button action-button" :class="{'action-button-active': action_button_state == 4}">
                  <button type="button" @click="toggleSlideOut('table-config')" v-shortkey="['alt', '4']" @shortkey="toggleSlideOut('table-config')">
                      <i class="fas fa-network-wired"></i>
                  </button>
                  <div class="teardrop-text">
                    <span> Configurare Tabel </span>
                  </div>
              </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                <clients ref="clientCompRef" :select_client_clone='select_client_clone'/>
            </div>
        </div>
        <div class="composition-template" id='composition-template-event'>
          <!-- <div class="template-composition-header">
            <b-form-checkbox
                    :title="check_addition ? 'Afiseaza adaos' : 'Ascunde adaos'"
                    v-model="check_addition"
                     @change="check_addition = !check_addition"
                     name="check-addition-button"
                     switch
                     >
            </b-form-checkbox>
          </div> -->
          <div class="general-template-info">
            <ul id="template-info-list">
                <li class="template-list-item">
                    <p class="main-heading"> {{$t('txt.numarOferta')}} </p>
                    <p> AUTO  </p>
                </li>
                <li class="template-list-item">
                    <p class="main-heading"> {{$t('txt.data')}}  </p>
                    <p> {{new Date() | moment("DD.MM.YYYY")}} </p>
                </li>
                <li class="template-list-item">
                    <p class="main-heading"> Data valabilitate </p>
                    <date-picker :not-before="new Date()" v-model="validity_date" value-type="format" type="date" lang="ro" format="DD-MM-YYYY"></date-picker>
                </li>
                <li class="template-list-item">
                    <button class="template-button" @click="cancelDocument('pending_offer', '/offers')">
                        Anuleaza oferta
                    </button>
                </li>
            </ul>
          </div>
          <div class="offer-table-wrapper">
              <table>
                  <thead>
                  <tr>
                    <th>
                        <p>
                            {{$t('tableHeader.nrCrt')}}
                        </p>
                    </th>
                      <th v-if="!checkboxes['name_check'].value" colspan="2">
                          <p class="final-table-header">
                              {{$t('placeholder.denumire')}}
                          </p>
                      </th>
                      <th v-if="!checkboxes['price_check'].value" class="tablehead-price">
                          <div class="type-price-header">
                              <p> {{$t('placeholder.tipPret')}} </p>
                              <b-form-select v-model="globalPriceRange.key" @input="changePriceProducts(changeProductsPriceCat)">
                                  <option v-for="(ppCateg, index) in priceCategoryes" :key="index" :value="ppCateg.value">{{ ppCateg.display }}</option>
                              </b-form-select>
                          </div>
                      </th>
                      <th v-if="!checkboxes['addition_check'].value && hideAddition">
                          <p class="final-table-header">
                              {{$t('tableHeader.adaos')}}
                          </p>
                      </th>
                      <th v-if="!checkboxes['discount_check'].value">
                          <p class="final-table-header">
                              {{$t('tableHeader.discount')}}
                          </p>
                      </th>
                      <th v-if="!checkboxes['quantity_check'].value">
                          <p class="final-table-header">
                              {{$t('placeholder.cantitate')}}
                          </p>
                      </th>
                      <th v-if="!checkboxes['subtotal_check'].value">
                          <p class="final-table-header">
                              {{$t('txt.subtotal')}}
                          </p>
                      </th>
                      <th>
                          <p class="final-table-header">
                              <!-- {{$t('placeholder.sterge')}} -->
                          </p>
                      </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(offer_row, index) in offer_rows.products" :data-order-row-id="offer_row.id" :key="offer_row.id">
                      <td>
                          <p> {{index + 1}} </p>
                      </td>
                      <td v-if="!checkboxes['name_check'].value"  colspan="2" :tableheadData="$t('placeholder.denumire')" class="order-prdname-wrapper" :class="(parseFloat(offer_row.prices['pp_minim']) > parseFloat(offer_row.price)) ? 'price-under-min' : ''">
                          <div class="final-offer-name final-order-name">
                              <p> {{offer_row.name}} </p>
                          </div>
                      </td>
                      <td v-if="!checkboxes['price_check'].value" :tableheadData="$t('placeholder.pret')">
                          <div class="type-price">
                              <b-form-select v-model="offer_row.price_category" @change="changePriceProduct(index)">
                                  <option v-for="(ppCateg, index) in priceCategoryes" :key="index" :value="ppCateg.value"> {{ ppCateg.display }} &nbsp; | &nbsp; {{ offer_row.prices[ppCateg.name] }}</option>
                              </b-form-select>
                              <i v-if="offer_row.price_category_indicator === 'up' " class="fas fa-plus"></i>
                              <i v-if="offer_row.price_category_indicator === 'down' " class="fas fa-minus"></i>
                              <i v-if="offer_row.price_category_indicator !== 'down' && offer_row.price_category_indicator !== 'up'" class="far fa-circle"></i>
                              <input type="number" v-model="offer_row.price" :data-price-active="index"  @input="changePriceProductInput(index)" @click="activatePriceInput(index)" @keypress.enter="increaseDataPrice()"/>
                          </div>
                      </td>
                      <td v-if="!checkboxes['addition_check'].value && hideAddition" :tableheadData="$t('tableHeader.adaos')" class="price-modifier-wrapper">
                          <div class="modifier-wrapper">
                            <div class="item-price-modifier addition-modifier">
                                <input type="number" v-model="offer_row.addition" :data-addition-active="index" min="1" max="100"
                                                    @input="inputAdditionProduct(index)"
                                                    @change="changeAdditionDiscountProduct(index)"
                                                    @keypress.enter="increaseDataAddition()"
                                                    @click="activateAdditionInput(index)">
                                <i class="fas fa-percentage"></i>
                            </div>
                            <i class="fas fa-arrow-down arrow-cursor" @dblclick="changeAdditionUnder(index)"></i>
                          </div>
                      </td>
                      <td v-if="!checkboxes['discount_check'].value" :tableheadData="$t('tableHeader.discount')" class="price-modifier-wrapper">
                          <div class="modifier-wrapper">
                            <div class="item-price-modifier">
                                <input type="number" v-model="offer_row.discount" :data-discount-active="index" min="1" max="100"
                                                    @input="inputDiscountProduct(index)"
                                                    @change="changeAdditionDiscountProduct(index)"
                                                    @keypress.enter="increaseDataDiscount()"
                                                    @click="activateDiscountInput(index)">
                                <i class="fas fa-percentage"></i>
                            </div>
                            <i class="fas fa-arrow-down arrow-cursor" @dblclick="changeDiscountUnder(index)"></i>
                          </div>
                      </td>
                      <td width="10%" v-if="!checkboxes['quantity_check'].value" :tableheadData="$t('placeholder.cantitate')">
                        <div class="item-qty-modifier">
                          <input type="number" v-model="offer_row.qty" :data-qty-active="index" min="1"
                                              @keypress.enter="increaseDataQty()"
                                              @click="activateQtyInput(index)"
                                              @input="offer_rows.products[index].qty = offer_rows.products[index].qty > 0 ? offer_rows.products[index].qty : 1">
                          <span>{{offer_row.um}}</span>
                        </div>
                      </td>
                      <td v-if="!checkboxes['subtotal_check'].value" :tableheadData="$t('txt.subtotal')">
                          <div class="final-offer-price">
                              <!-- <p> {{(offer_row.price * offer_row.qty) + (offer_row.addition || 0)/100*(offer_row.price * offer_row.qty) - (offer_row.discount || 0)/100*(offer_row.price * offer_row.qty)  | formatPrice}} </p> -->
                              <p> {{(offer_row.price * offer_row.qty) | formatPrice}} </p>
                              <!--<p> RON </p>-->
                          </div>
                      </td>
                      <td :tableheadData="$t('placeholder.sterge')">
                          <div class="final-offer-remove" @click="removeItem(index, 'products')">
                              <i class="fas fa-times"></i>
                          </div>
                      </td>
                  </tr>
                  <tr v-for="(offer_row, index) in offer_rows.services" :key="offer_row.id">
                      <td :tableheadData="$t('placeholder.denumire')">
                          <div class="final-offer-name final-order-name">
                              <p> {{offer_row.name}} </p>
                          </div>
                      </td>
                      <td :tableheadData="$t('placeholder.pret')">
                          <div class="final-offer-price">
                              <p> {{offer_row.price | formatPrice}} </p>
                              <!-- <div class="type-price">
                                  <b-form-select v-model="selected" :options="options"></b-form-select>
                              </div> -->
                          </div>
                      </td>
                      <td :tableheadData="$t('placeholder.cantitate')">
                          <div class="final-offer-qty">
                              <p> {{offer_row.qty}} </p>
                          </div>
                      </td>
                      <td :tableheadData="$t('txt.subtotal')">
                          <div class="final-offer-price">
                              <p> {{offer_row.price * offer_row.qty | formatPrice}} </p>
                              <!--<p> RON </p>-->
                          </div>
                      </td>
                      <td :tableheadData="$t('tableHeader.adaos')">
                          <div class="item-price-modifier">
                              <input type="number" min="1" max="100">
                          </div>
                      </td>
                      <td :tableheadData="$t('tableHeader.discount')">
                          <div class="item-price-modifier">
                              <input type="number" min="1" max="100">
                          </div>
                      </td>
                      <td :tableheadData="$t('placeholder.sterge')">
                          <div class="final-offer-remove" @click="removeItem(index, 'services')">
                              <i class="fas fa-times"></i>
                          </div>
                      </td>
                  </tr>
                  <tr v-for="(offer_row, index) in offer_rows.post_services" :key="offer_row.id">
                      <td :tableheadData="$t('placeholder.denumire')">
                          <div class="final-offer-name final-order-name">
                              <p> {{offer_row.name}} </p>
                          </div>
                      </td>
                      <td :tableheadData="$t('placeholder.pret')">
                          <div class="final-offer-price">
                              <p> {{offer_row.price | formatPrice}} </p>
                              <!-- <div class="type-price">
                                  <b-form-select v-model="selected" :options="options"></b-form-select>
                              </div> -->
                          </div>
                      </td>
                      <td :tableheadData="$t('placeholder.cantitate')">
                          <div class="final-offer-qty">
                              <p> {{offer_row.qty}} </p>
                          </div>
                      </td>
                      <td :tableheadData="$t('txt.subtotal')">
                          <div class="final-offer-price">
                              <p> {{offer_row.price * offer_row.qty | formatPrice}} </p>
                              <!--<p> RON </p>-->
                          </div>
                      </td>
                      <td :tableheadData="$t('tableHeader.adaos')">
                          <div class="item-price-modifier">
                              <input type="number" min="1" max="100">
                          </div>
                      </td>
                      <td :tableheadData="$t('tableHeader.discount')">
                          <div class="item-price-modifier">
                              <input type="number" min="1" max="100">
                          </div>
                      </td>
                      <td :tableheadData="$t('placeholder.sterge')">
                          <div class="final-offer-remove" @click="removeItem(index, 'post_services')">
                              <i class="fas fa-times"></i>
                          </div>
                      </td>
                  </tr>
                  </tbody>
              </table>
          </div>
        </div>
        <div class="composition-info">
            <ul>
                <li>
                    <h5> {{$t('txt.subtotal')}}  </h5>
                    <p> {{this.subtotal | formatPrice}} </p>
                </li>
                <li>
                    <h5> {{$t('tableHeader.discount')}}  </h5>
                    <span class="discount-label"> <i class="fas fa-percentage"></i> </span>
                    <input type="number" v-model="discount" min="1" max="100">
                </li>
                <li>
                    <h5> {{$t('txt.total')}}  </h5>
                    <p> {{this.total | formatPrice}}</p>
                </li>
                <li>
                  <div class="discount-check-line">
                    <b-form-checkbox
                    v-b-tooltip.hover :title="totalDiscountCheckbox ?  'Nu afisa in oferta' : 'Afiseaza in oferta'"
                    name="discount-check"
                    v-model="totalDiscountCheckbox"
                    >
                    </b-form-checkbox>
                    <h5> Discount total </h5>
                  </div>
                  <p> {{this.discountTotal().value | formatPrice}} ({{this.discountTotal().percentage | formatPrice}} %) </p>
                </li>
                <li class="addition-info-line" v-if="!checkboxes['addition_check'].value && hideAddition" v-bind:class="{'addition-modifier-inactive': checkboxes['addition_check'].value}">
                  <h5> Adaos total </h5>
                  <p> {{this.addition.value | formatPrice}} ({{this.addition.percentage | formatPrice}} %) </p>
                </li>
                <li class="final-info-save">
                    <button class="template-button" type="button" @click="saveOffer(1)">
                        <i class="fas fa-download"></i>
                        {{$t('placeholder.descarcaOferta')}}
                    </button>
                </li>
                <li class="final-info-save">
                    <button class="template-button" type="button" @click="saveOffer()">
                        <i class="far fa-save"></i>
                        {{$t('placeholder.salveazaOferta')}}
                    </button>
                </li>
                <li class="final-info-save">
                    <button class="template-button" v-b-modal.email-check type="button">
                        <i class="far fa-paper-plane"></i>
                        {{$t('placeholder.trimiteOferta')}}
                    </button>
                </li>
            </ul>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="template-additional-info">
              <div class="additional-info-input">
                <div class="additional-info additional-first">
                  <label for="objectiv">
                    <i v-if="search_results_orders != null || search_results_offers != null" class="fas fa-exclamation-triangle"></i>
                    Obiectivul:
                  </label>
                  <input
                  v-model="objective"
                  />
                  <ul class="search-similar-results">
                    <li v-for="order in search_results_orders" :key="order.id">
                      <router-link target='_blank' tabindex="1" :to="{ name: 'vieworder', params: { id: order.id }}" class="view-user" v-if="$can(['view order'])">
                                   Comanda {{order.id}} -  {{order.objective}}
                      </router-link>
                      <span v-else>  Comanda {{order.id}} -  {{order.objective}} </span>
                    </li>
                    <li v-for="offer in search_results_offers" :key="offer.id">
                      <router-link target='_blank' abindex="1" :to="{ name: 'viewoffer', params: { id: offer.id }}" class="view-user" v-if="$can(['view offer'])">
                                   Oferta {{offer.id}} -  {{offer.objective}}
                      </router-link>

                      <span v-else> Oferta {{offer.id}} -  {{offer.objective}}</span>
                    </li>
                  </ul>
                </div>
                <div class="additional-info additional-second">
                  <label for="representative_prod">
                    Produse Reprezentative:
                  </label>
                  <input
                  v-model="representative_products"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-xl-6 col-lg-6 col-md-12 col-12">
            <div class="template-description-setup">
              <h4> Configureaza descriere </h4>
              <div class="template-description-options">
                <h5> {{$t('placeholder.alegeSablon')}} </h5>
                <v-select v-model="select_offer_template" :options="offer_templates" label="name">  </v-select>
              </div>
              <div class="template-description-editor">
                <h5> {{$t('txt.descriereOferta')}} </h5>
                <ckeditor :editor="editor" v-model="offer_description" :config="editorConfig"></ckeditor>
              </div>
            </div>
          </div>
        </div>
        <div class="table-config-slideout">
            <div id="table-column-config">
              <div class="table-config-close" @click="tableConfigClose()">
                <p> <i class="fas fa-times"></i> </p>
              </div>
              <div :key="checkboxesKey">
                <div class="table-checkbox-container" v-for="(checkbox, key) in checkboxes" :id="key" :key="key">
                    <template v-if="key === 'addition_check' && hideAddition">
                        <span> {{checkbox.name}}</span>
                        <b-form-checkbox
                                v-b-tooltip.hover :title="checkbox.value ? 'Afiseaza' : 'Ascunde'"
                                v-model="checkbox.value"
                                :name="key"
                                @change="changeCheckbox(key)"
                                switch
                        >
                        </b-form-checkbox>
                    </template>
                    <template v-else-if="key !== 'addition_check'">
                        <span> {{checkbox.name}} </span>
                        <b-form-checkbox
                                v-b-tooltip.hover :title="checkbox.value ? 'Afiseaza' : 'Ascunde'"
                                v-model="checkbox.value"
                                :name="key"
                                @change="changeCheckbox(key)"
                                switch
                        >
                        </b-form-checkbox>
                    </template>

              </div>
              </div>
          </div>
        </div>
        <div class="certified-label">
            <div class="certified-logo">
                <p v-if="$hasRole(['partner'])"> {{$t('placeholder.partenerCompanie')}} </p>
                <img src="/logo.png">
            </div>
        </div>
        <b-modal id="email-check" ref="email-check" hide-footer hide-header>
          <div class="custom-modal-header">
            <h4>
              Trimite Oferta
            </h4>
          </div>
          <div class="custom-modal-body" v-if="select_client">
            <div class="form-group">
              <input type="text" name="" :value="clientName (select_client)" class="form-control">
              <label> Nume </label>
              <span class="focus-input"></span>
              <span class="symbol-input">
                  <i class="fas fa-signature"></i>
              </span>
            </div>
            <div class="form-group">
              <input type="email" name="email" v-model="select_client.email" class="form-control">
              <label> Email </label>
              <span class="focus-input"></span>
              <span class="symbol-input">
                  <i class="far fa-envelope"></i>
              </span>
            </div>
          </div>
          <div class="custom-modal-footer">
            <button class="custom-modal-button custom-modal-cancel" type="button" @click='hideCustomModal()'> Anuleaza </button>
            <button class="custom-modal-button custom-modal-ok" @click='saveOffer(3)'> Trimite! </button>
          </div>
        </b-modal>
        <b-modal id="modal-scrollable" size="xl" scrollable hide-header no-close-on-backdrop>
            <div class="user-logo-container" v-if="this.user">
                <div class="user-logo">
                    <img :src="logo">
                </div>
            </div>
            <template slot="default">
                <div class="offer-header">
                    <div class="page-title">
                        <h5> Previzualizare oferta </h5>
                    </div>
                </div>
                <div class="general-template-info">
                  <ul>
                    <li>
                      <p class="main-heading"> {{$t('txt.numarOferta')}} </p>
                      <p> AUTO  </p>
                    </li>
                    <li>
                      <p class="main-heading"> {{$t('txt.data')}}  </p>
                      <p> {{new Date() | moment("DD.MM.YYYY")}} </p>
                    </li>
                  </ul>
                </div>
                <div class="row justify-content-center">
                  <div class="col-xl-6 col-lg-6 col-md-12">
                    <ul class="template-offer-details" v-if="select_client">
                        <h4> {{$t('txt.dateClient')}} </h4>
                        <li> <span> {{$t('placeholder.numeCompanie')}}: </span> <p>{{select_client.company_name ? select_client.company_name : '-'}} </p> </li>
                        <li> <span> {{$t('placeholder.nume')}}: </span> <p>{{select_client.last_name}} {{select_client.first_name}} </p> </li>
                        <li> <span> {{$t('placeholder.email')}}: </span> <p>{{select_client.email}} </p> </li>
                        <li> <span> {{$t('placeholder.telefon')}}: </span> <p>{{select_client.phone}} </p> </li>
                    </ul>
                  </div>
                </div>
                <div class="preview-offer-desc">
                    <p v-html="offer_description">
                    </p>
                </div>
                <h4> {{$t('txt.ofertaFinala')}} </h4>
                <div class="table-responsive">
                    <table class="table table-striped table-bordered">
                        <thead>
                        <tr>
                            <th>
                                <span>
                                    {{$t('tableHeader.nrCrt')}}
                                </span>
                            </th>
                            <th>
                                <span>
                                    {{$t('placeholder.denumire')}}
                                </span>
                            </th>
                            <th>
                                <span>
                                    {{$t('placeholder.pret')}}
                                </span>
                            </th>
                            <th>
                                <span>
                                    {{$t('placeholder.cantitate')}}
                                </span>
                            </th>
                            <th>
                                <span>
                                    {{$t('txt.subtotal')}}
                                </span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(offer_row,index) in offer_rows.products" :key="`modal-products-${index}`">
                                <td>
                                    <p> {{index + 1}} </p>
                                </td>
                                <td :tableheadData="$t('placeholder.denumire')">
                                    <span> {{offer_row.name}} </span>
                                </td>
                                <td :tableheadData="$t('placeholder.pret')">
                                    <span> {{offer_row.price | formatPrice}} </span>
                                </td>
                                <td :tableheadData="$t('placeholder.cantitate')">
                                    <span> {{offer_row.qty}} </span>
                                </td>
                                <td :tableheadData="$t('txt.subtotal')">
                                    <span> {{offer_row.price * offer_row.qty | formatPrice}} </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="template-preview-total">
                    <ul>
                        <li>
                            <h5> {{$t('txt.subtotal')}}:  </h5>
                            <p> {{this.subtotal | formatPrice}} </p>
                        </li>
                        <li>
                            <h5> {{$t('tableHeader.discount')}}  </h5>
                            <span> {{discount}} % </span>
                        </li>
                        <li>
                            <h5> {{$t('txt.total')}}  </h5>
                            <p> {{this.total | formatPrice}}</p>
                        </li>
                    </ul>
                </div>
            </template>
            <template slot="modal-footer">
                <div class="modal-certified-label">
                    <div class="modal-certified-logo">
                        <img src="/logo.png">
                    </div>
                    <p v-if="$hasRole(['partner'])"> {{$t('placeholder.partenerCompanie')}} </p>
                </div>
                <div class="modal-bottom-wrapper">
                    <button class="template-button" type="button" @click="closeModal()">
                        {{$t('txt.inchide')}}
                    </button>
                </div>
            </template>
        </b-modal>

        <div id="product-slideout">
          <offer-products
                          @addItem="addItem"/>
        </div>
    </div>
</template>

<script>
import ProductsService from '../../api-services/products.service'
import OfferTemplatesService from '../../api-services/offer-templates.service.js'
import OffersService from '../../api-services/offers.service.js'
import OrdersService from '../../api-services/orders.service.js'
import localforage from 'localforage'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import OfferProducts from '../../components/OfferProducts'
import Clients from '../../components/Clients'
import DatePicker from 'vue2-datepicker'
import { EventBus } from '../../main.js'

export default {
  name: 'CreateOffer',
  components: {
    'date-picker': DatePicker,
    'offer-products': OfferProducts,
    'clients': Clients
  },
  data () {
    return {
      modalEmailState: false,
      checkboxes: {
        name_check: { value: false, name: 'Denumire' },
        price_check: { value: false, name: 'Tip pret' },
        addition_check: { value: true, name: 'Adaos' },
        discount_check: { value: true, name: 'Discount' },
        quantity_check: { value: false, name: 'Cantitate' },
        subtotal_check: { value: false, name: 'Subtotal' }
      },
      select_client_clone: null,
      checkboxesKey: 1,
      logo: null,
      user: this.$store.getters.user,
      check_addition: false,
      validity_date: null,
      editor: ClassicEditor,
      editorConfig: {
        // The configuration of the editor.
      },
      globalPriceRange: {
        key: 5,
        name: 'pp_amanunt'
      },
      priceCategoryes: null,
      action_button_state: undefined,
      products: [],
      offer_templates: [],
      services: null,
      offer_description: '',
      post_services: null,
      select_client: null,
      select_partner: null,
      select_offer_template: null,
      selected_search_header: null,
      search_products: '',
      search_services: '',
      search_post_services: '',
      client_new_email: false,
      offer_headings: [],
      discount: 0,
      previewPdf: null,
      offer_rows: {
        products: [],
        services: [],
        post_services: []
      },
      search_results_orders: null,
      search_results_offers: null,
      meta_products: {},
      meta_services: {},
      meta_post_services: {},
      isShown: false,
      userWarehouses: [],
      warehouses: [],
      objective: null,
      representative_products: null,
      search_objective: null,
      search_results: {
        offers: [],
        orders: []
      },
      lastDataPriceActive: null,
      lastDataAdditionActive: null,
      lastDataDiscountActive: null,
      lastDataQtyActive: null,
      totalDiscountCheckbox: false,
      hideAddition: true,
      compHistory: null,
      changeProductsPriceCat: true
      // clicksOutside: 0
    }
  },
  watch: {
    objective: window._.debounce(async function (newVal, oldVal) {
      if (newVal !== '') {
        await this.searchObjectiveInOrdersAndOffers(newVal)
      } else {
        this.search_results_orders = null
        this.search_results_offers = null
      }
    }, 1000),
    select_client: function (newVal, oldVal) {
      if (newVal === null) {
        this.isShown = false
        this.select_partner = null
      }
    },
    select_offer_template: function (value) {
      if (value) {
        this.offer_description = value.text
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.compHistory)
  },
  mounted () {
    let vm = this
    this.compHistory = setInterval(() => {
      let pendingOffer = {
        offer_rows: vm.offer_rows,
        objective: vm.objective,
        representative_products: vm.representative_products,
        validity_date: vm.validity_date
      }
      localforage.setItem('pending_offer', pendingOffer)
    }, 2000)
    document.getElementById('composition-template-event').addEventListener('keydown', event => {
      let element = document.getElementById('product-slideout')
      let statPrice = false
      let statAddition = false
      let statDiscount = false
      let statQty = false

      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.getAttribute('data-price-active') !== null) {
        statPrice = true
        event.preventDefault()
        if (event.keyCode === 40) {
          vm.lastDataPriceActive = vm.lastDataPriceActive == null ? 0 : vm.lastDataPriceActive + 1
          if (vm.lastDataPriceActive === vm.offer_rows.products.length) {
            vm.lastDataPriceActive--
          }
        } else {
          vm.lastDataPriceActive = vm.lastDataPriceActive < 1 ? 0 : vm.lastDataPriceActive - 1
        }
        window.$('[data-price-active=' + vm.lastDataPriceActive + ']').focus().select()
      }

      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.getAttribute('data-addition-active') !== null) {
        statAddition = true
        event.preventDefault()
        if (event.keyCode === 40) {
          vm.lastDataAdditionActive = vm.lastDataAdditionActive == null ? 0 : vm.lastDataAdditionActive + 1
          if (vm.lastDataAdditionActive === vm.offer_rows.products.length) {
            vm.lastDataAdditionActive--
          }
        } else {
          vm.lastDataAdditionActive = vm.lastDataAdditionActive < 1 ? 0 : vm.lastDataAdditionActive - 1
        }
        window.$('[data-addition-active=' + vm.lastDataAdditionActive + ']').focus().select()
      }

      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.getAttribute('data-qty-active') !== null) {
        statQty = true
        event.preventDefault()
        if (event.keyCode === 40) {
          vm.lastDataQtyActive = vm.lastDataQtyActive == null ? 0 : vm.lastDataQtyActive + 1
          if (vm.lastDataQtyActive === vm.offer_rows.products.length) {
            vm.lastDataQtyActive--
          }
        } else {
          vm.lastDataQtyActive = vm.lastDataQtyActive < 1 ? 0 : vm.lastDataQtyActive - 1
        }
        window.$('[data-qty-active=' + vm.lastDataQtyActive + ']').focus().select()
      }

      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.getAttribute('data-discount-active') !== null) {
        statDiscount = true
        event.preventDefault()
        if (event.keyCode === 40) {
          vm.lastDataDiscountActive = vm.lastDataDiscountActive == null ? 0 : vm.lastDataDiscountActive + 1
          if (vm.lastDataDiscountActive === vm.offer_rows.products.length) {
            vm.lastDataDiscountActive--
          }
        } else {
          vm.lastDataDiscountActive = vm.lastDataDiscountActive < 1 ? 0 : vm.lastDataDiscountActive - 1
        }
        window.$('[data-discount-active=' + vm.lastDataDiscountActive + ']').focus().select()
      }

      if ((event.keyCode >= 65 && event.keyCode <= 90) && element.classList.contains('slideout-open') && (statPrice || statAddition || statDiscount || statQty)) {
        let searchProducts = document.getElementById('product-search')
        if (document.activeElement.closest('#product-slideout') !== null) {
          if (document.activeElement !== searchProducts) {
            vm.search_products = ''
            searchProducts.focus()
          }
        }
      }

      if (event.keyCode === 8 && element.classList.contains('slideout-open') && document.activeElement.getAttribute('data-product') === null) {
        let searchProducts = document.getElementById('product-search')
        if (document.activeElement.closest('#product-slideout') !== null) {
          if (document.activeElement !== searchProducts) {
            searchProducts.focus()
          }
        }
      }
    })
  },
  methods: {
    showModal () {
      this.action_button_state = 1
      this.$bvModal.show('modal-scrollable')
      let tableConfig = document.getElementById('table-column-config')
      tableConfig.classList.remove('config-active')
    },
    closeModal () {
      this.action_button_state = undefined
      this.$bvModal.hide('modal-scrollable')
    },
    hideCustomModal () {
      this.$refs['email-check'].hide()
    },
    changeCheckbox (name) {
      if (name === 'addition_check') {
        if (this.checkboxes[name].value === true) {
          if (confirm('Sunteti sigur?')) {
            this.checkboxes[name].value = !this.checkboxes[name].value
          }
        } else {
          this.checkboxes[name].value = !this.checkboxes[name].value
        }
      } else {
        this.checkboxes[name].value = !this.checkboxes[name].value
      }
      this.checkboxesKey++
    },
    discountTotal () {
      let totalMax = 0
      this.offer_rows.products.forEach(function (element) {
        totalMax += parseFloat(element.prices.pp_amanunt).toFixed(2) * parseInt(element.qty)
      })
      let disscountTotal = {}
      disscountTotal.value = -(this.total - totalMax)
      disscountTotal.value = disscountTotal.value > 0 ? disscountTotal.value : 0.00
      disscountTotal.percentage = ((100 * disscountTotal.value) / totalMax) || 0
      disscountTotal.percentage = disscountTotal.percentage > 0 ? disscountTotal.percentage : 0.00
      disscountTotal.value = parseFloat(disscountTotal.value).toFixed(2)
      disscountTotal.percentage = parseFloat(disscountTotal.percentage).toFixed(2)
      return disscountTotal
    },
    changeAdditionUnder (index) {
      for (let i = index + 1; i < this.offer_rows.products.length; i++) {
        this.offer_rows.products[i].addition = this.offer_rows.products[index].old_addition_fixed || this.offer_rows.products[index].addition
        this.inputAdditionProduct(i)
        this.changeAdditionDiscountProduct(i)
      }
    },
    changeDiscountUnder (index) {
      for (let i = index + 1; i < this.offer_rows.products.length; i++) {
        this.offer_rows.products[i].discount = this.offer_rows.products[index].old_discount_fixed || this.offer_rows.products[index].discount
        this.inputDiscountProduct(i)
        this.changeAdditionDiscountProduct(i)
      }
    },
    activatePriceInput (index) {
      this.lastDataPriceActive = index
      window.$('[data-price-active=' + this.lastDataPriceActive + ']').focus().select()
    },
    activateAdditionInput (index) {
      this.lastDataAdditionActive = index
      window.$('[data-addition-active=' + this.lastDataAdditionActive + ']').focus().select()
    },
    activateQtyInput (index) {
      this.lastDataQtyActive = index
      window.$('[data-qty-active=' + this.lastDataQtyActive + ']').focus().select()
    },
    activateDiscountInput (index) {
      this.lastDataDiscountActive = index
      window.$('[data-discount-active=' + this.lastDataDiscountActive + ']').focus().select()
    },
    increaseDataPrice () {
      this.lastDataPriceActive = this.lastDataPriceActive < this.offer_rows.products.length - 1 ? this.lastDataPriceActive + 1 : this.lastDataPriceActive
      window.$('[data-price-active=' + this.lastDataPriceActive + ']').focus().select()
    },
    increaseDataAddition () {
      this.lastDataAdditionActive = this.lastDataAdditionActive < this.offer_rows.products.length - 1 ? this.lastDataAdditionActive + 1 : this.lastDataAdditionActive
      window.$('[data-addition-active=' + this.lastDataAdditionActive + ']').focus().select()
    },
    increaseDataQty () {
      this.lastDataQtyActive = this.lastDataQtyActive < this.offer_rows.products.length - 1 ? this.lastDataQtyActive + 1 : this.lastDataQtyActive
      window.$('[data-qty-active=' + this.lastDataQtyActive + ']').focus().select()
    },
    increaseDataDiscount () {
      this.lastDataDiscountActive = this.lastDataDiscountActive < this.offer_rows.products.length - 1 ? this.lastDataDiscountActive + 1 : this.lastDataDiscountActive
      window.$('[data-discount-active=' + this.lastDataDiscountActive + ']').focus().select()
    },
    changePriceProducts () {
      let priceCat = this.priceCategoryes.find(price => parseInt(price.value) === parseInt(this.globalPriceRange.key))
      this.globalPriceRange.name = priceCat.name
      for (let i = 0; i < this.offer_rows.products.length; i++) {
        this.offer_rows.products[i].price_category = this.globalPriceRange.key
        this.offer_rows.products[i].price = this.offer_rows.products[i].prices[this.globalPriceRange.name]
        this.offer_rows.products[i].price_fixed = this.offer_rows.products[i].prices[this.globalPriceRange.name]
        this.offer_rows.products[i].price_category_name = this.globalPriceRange.name
        this.offer_rows.products[i].price_category_indicator = 'stable'
        this.offer_rows.products[i].addition = parseFloat((this.offer_rows.products[i].price - this.offer_rows.products[i].prices.pp_minim) / this.offer_rows.products[i].prices.pp_minim * 100).toFixed(2)
        this.offer_rows.products[i].discount = parseFloat(-(this.offer_rows.products[i].price - this.offer_rows.products[i].prices['pp_amanunt']) / this.offer_rows.products[i].prices['pp_amanunt'] * 100).toFixed(2)
      }
    },
    changePriceProduct (i) {
      let priceCat = this.priceCategoryes.find(price => price.value === this.offer_rows.products[i].price_category)
      this.offer_rows.products[i].price = this.offer_rows.products[i].prices[priceCat.name]
      this.offer_rows.products[i].price_category_name = priceCat.name
      this.offer_rows.products[i].price_category_indicator = 'stable'
      this.offer_rows.products[i].addition = parseFloat((this.offer_rows.products[i].price - this.offer_rows.products[i].prices.pp_minim) / this.offer_rows.products[i].prices.pp_minim * 100).toFixed(2)
      this.offer_rows.products[i].discount = parseFloat(-(this.offer_rows.products[i].price - this.offer_rows.products[i].prices.pp_amanunt) / this.offer_rows.products[i].prices.pp_amanunt * 100).toFixed(2)
      this.offer_rows.products[i].price_fixed = this.offer_rows.products[i].price
    },
    changePriceProductInput (i) {
      this.offer_rows.products[i].addition = parseFloat((this.offer_rows.products[i].price - this.offer_rows.products[i].prices.pp_minim) / this.offer_rows.products[i].prices.pp_minim * 100).toFixed(2)
      this.offer_rows.products[i].discount = parseFloat(-(this.offer_rows.products[i].price - this.offer_rows.products[i].prices.pp_amanunt) / this.offer_rows.products[i].prices.pp_amanunt * 100).toFixed(2)
      this.offer_rows.products[i].discount = this.offer_rows.products[i].discount > 0 ? this.offer_rows.products[i].discount : parseFloat(0.00).toFixed(2)
      this.machProductPriceCategory(i)
      this.offer_rows.products[i].price_fixed = this.offer_rows.products[i].price
    },
    inputDiscountProduct (i) {
      let prodDiscount = this.offer_rows.products[i].discount > 0 ? this.offer_rows.products[i].discount : 0
      this.offer_rows.products[i].price = parseFloat(this.offer_rows.products[i].price_fixed - prodDiscount / 100 * this.offer_rows.products[i].price_fixed)
      this.offer_rows.products[i].old_discount_fixed = this.offer_rows.products[i].discount
      this.machProductPriceCategory(i)
    },
    inputAdditionProduct (i) {
      let prodAddition = this.offer_rows.products[i].addition > 0 ? this.offer_rows.products[i].addition : 0
      this.offer_rows.products[i].price = parseFloat(Number(this.offer_rows.products[i].price_fixed) + Number(prodAddition) / 100 * Number(this.offer_rows.products[i].price_fixed))
      this.offer_rows.products[i].old_addition_fixed = this.offer_rows.products[i].addition
      this.machProductPriceCategory(i)
    },
    changeAdditionDiscountProduct (i) {
      this.changeInputNull(i)
      this.offer_rows.products[i].price_fixed = parseFloat(this.offer_rows.products[i].price).toFixed(2)
      this.offer_rows.products[i].addition = parseFloat((this.offer_rows.products[i].price - this.offer_rows.products[i].prices.pp_minim) / this.offer_rows.products[i].prices.pp_minim * 100).toFixed(2)
      this.offer_rows.products[i].addition = this.offer_rows.products[i].addition > 0 ? this.offer_rows.products[i].addition : parseFloat(0.00).toFixed(2)
      this.offer_rows.products[i].discount = parseFloat(-(this.offer_rows.products[i].price - this.offer_rows.products[i].prices.pp_amanunt) / this.offer_rows.products[i].prices.pp_amanunt * 100).toFixed(2)
      this.offer_rows.products[i].discount = this.offer_rows.products[i].discount > 0 ? this.offer_rows.products[i].discount : parseFloat(0.00).toFixed(2)
      this.offer_rows.products[i].price = parseFloat(this.offer_rows.products[i].price).toFixed(2)
    },
    changeInputNull (i) {
      this.offer_rows.products[i].addition = this.offer_rows.products[i].addition > 0 ? this.offer_rows.products[i].addition : parseFloat(0.00).toFixed(2)
      this.offer_rows.products[i].discount = this.offer_rows.products[i].discount > 0 ? this.offer_rows.products[i].discount : parseFloat(0.00).toFixed(2)
    },
    machProductPriceCategory (index) {
      let prices = this.offer_rows.products[index].prices
      prices = Object.keys(prices).map(function (key) {
        return { value: parseFloat(prices[key]), name: key }
      })
      prices.push({ value: parseFloat(this.offer_rows.products[index].price), name: 'selected_price' })
      prices = prices.sort((a, b) => a.value >= b.value ? 1 : -1)

      let priceCatName = null
      let priceCatIndicator = 'stable'
      for (let i = 0; i < prices.length; i++) {
        if (prices[i].name === 'selected_price' && i === 0) {
          priceCatName = prices[i + 1].name
          if (prices[i].value === prices[i + 1].value) {
            priceCatIndicator = 'stable'
          } else {
            priceCatIndicator = 'down'
          }
          break
        }

        if (prices[i].name === 'selected_price' && i === prices.length - 1) {
          priceCatName = prices[i - 1].name
          if (prices[i].value === prices[i - 1].value) {
            priceCatIndicator = 'stable'
          } else {
            priceCatIndicator = 'up'
          }
          break
        }

        if (prices[i].name === 'selected_price') {
          if (prices[i].value === prices[i - 1].value) {
            priceCatName = prices[i - 1].name
            priceCatIndicator = 'stable'
            break
          }

          if (prices[i].value === prices[i + 1].value) {
            priceCatName = prices[i + 1].name
            priceCatIndicator = 'stable'
            break
          }

          if (prices[i].value <= (prices[i - 1].value + prices[i + 1].value) / 2) {
            priceCatName = prices[i - 1].name
            priceCatIndicator = 'up'
            break
          } else {
            priceCatName = prices[i + 1].name
            priceCatIndicator = 'down'
            break
          }
        }
      }

      let priceCat = this.priceCategoryes.find(p => p.name === priceCatName)
      if (priceCat) {
        this.offer_rows.products[index].price_category_indicator = priceCatIndicator
        this.offer_rows.products[index].price_category_name = priceCatName
        this.offer_rows.products[index].price_category = priceCat.value
        return true
      } else {
        this.offer_rows.products[index].price_category_indicator = null
        this.offer_rows.products[index].price_category_name = null
        this.offer_rows.products[index].price_category = null
        return null
      }
    },
    tableConfigClose () {
      this.action_button_state = undefined
      let tableConfig = document.getElementById('table-column-config')
      tableConfig.classList.remove('config-active')
      this.$root.$emit('bv::hide::tooltip')
    },
    toggleSlideOut (target) {
      let sliderProducts = document.getElementById('product-slideout')
      let mainContainer = document.getElementById('page-content-wrapper')
      let searchProducts = document.getElementById('product-search')
      let tableConfig = document.getElementById('table-column-config')
      switch (target) {
        case 'products':
          this.action_button_state = 2
          sliderProducts.classList.add('slideout-open')
          mainContainer.classList.add('changed-position')
          tableConfig.classList.remove('config-active')
          searchProducts.focus()
          break
        case 'table-config':
          this.action_button_state = 4
          mainContainer.classList.remove('changed-position')
          sliderProducts.classList.remove('slideout-open')
          tableConfig.classList.add('config-active')
          break
        default:
      }
      this.addBodyClass()
    },
    closeSlideout () {
      this.action_button_state = undefined
      window.$('#table-column-config').removeClass('config-active')
      window.$('.action-button').removeClass('action-button-active')
      window.$('#product-slideout').removeClass('slideout-open')
      window.$('#page-content-wrapper').removeClass('changed-position')
      this.addBodyClass()
    },
    setTooltipTitle (section = null, clearReturn = false) {
      let output = []
      if (clearReturn) {
        this.$root.$emit('bv::hide::tooltip')
        return false
      }
      if (this.search_results[section].length) {
        this.search_results[section].forEach(function (item) {
          output.push(item.id)
        })
        return output.join(', ')
      }
    },
    searchObjectiveInOrdersAndOffers (val) {
      OrdersService.searchInOrders(val)
        .then((response) => {
          this.search_results_orders = response.data.data
        })

      OffersService.searchInOffers(val)
        .then((response) => {
          this.search_results_offers = response.data.data
        })
    },
    getQty (stocks, warehouseId) {
      if (stocks.length > 0) {
        let stock = stocks.find(function (element) {
          return parseInt(element.warehouse_id) === parseInt(warehouseId)
        })
        if (stock) {
          return stock.qty
        }
      }
      return 0
    },
    getQtyReserved (stocks, warehouseId) {
      if (stocks.length > 0) {
        let stock = stocks.find(function (element) {
          return parseInt(element.warehouse_id) === parseInt(warehouseId)
        })
        if (stock) {
          return stock.reserved
        }
      }
      return 0
    },
    checkLogo () {
      if (this.user.logo && this.user.logo.length) {
        this.logo = this.user.logo[0].link
      } else {
        this.logo = null
      }
    },
    getOfferTemplates () {
      OfferTemplatesService.getAll({ per_page: -1 })
        .then((response) => {
          this.offer_templates = response.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    increaseQuantity (index, collection) {
      this[collection][index]['qty']++
      // this.checkQuantity(index, collection)
    },
    decreaseQuantity (index, collection) {
      this[collection][index]['qty']--
      // this.checkQuantity(index, collection)
    },
    checkQuantity (index, collection) {
      let collectionName = ''
      switch (collection) {
        case 'products':
          collectionName = this.$t('placeholder.headerProduse')
          break

        case 'services':
          collectionName = this.$t('placeholder.headerServicii')
          break

        case 'post_services':
          collectionName = this.$t('placeholder.headerServiciiPostVanzare')
          break
      }
      if (this[collection][index]['qty'] < 1) {
        this[collection][index]['qty'] = 1
        this.$notify({
          group: 'warning',
          type: 'warn',
          text: 'Cantitatea minima care poate fi adaugata este de 1 ' + collectionName,
          'animation-type': 'css'
        })
        return false
      }

      if (this[collection][index]['qty'] > 99) {
        this[collection][index]['qty'] = 99
        this.$notify({
          group: 'warning',
          type: 'warn',
          text: 'Cantitatea maxima care poate fi adaugata este de 99 ' + collectionName,
          'animation-type': 'css'
        })
        return false
      }

      if (this[collection][index]['qty'] > this[collection][index]['stoc']) {
        this[collection][index]['qty'] = this[collection][index]['stoc']
        this.$notify({
          group: 'warning',
          type: 'warn',
          text: 'Din pacate mai sunt doar ' + this[collection][index]['stoc'] + ' ' + collectionName + ' pe stoc',
          'animation-type': 'css'
        })
        return false
      }
      return true
    },
    addItem (data) {
      let product = data.product
      let prodQty = data.input.value
      let row = this.offer_rows['products'].find(row => row.id === product.id)
      if (row) {
        row.qty += parseInt(prodQty)
        product['stoc'] = product['stoc'] - product.qty
        product['qty'] = 1
        this.$notify({
          group: 'succes',
          type: 'success',
          // title: 'Added',
          text: 'Produsul a fost adaugat in oferta',
          'animation-type': 'css'
        })
      } else {
        let obj = {
          id: data.product.id,
          orderId: data.orderId || null,
          price_category: _.clone(this.globalPriceRange.key),
          price_category_name: _.clone(this.globalPriceRange.name),
          price: data.orderId ? data.productInfo.price : data.product.prices[_.clone(this.globalPriceRange.name)],
          price_fixed: data.orderId ? data.productInfo.price : data.product.prices[_.clone(this.globalPriceRange.name)],
          prices: data.product.prices,
          name: data.product.name,
          qty: parseInt(prodQty),
          um: data.product.um
        }
        obj['addition'] = parseFloat((obj.price - data.product.prices.pp_minim) / data.product.prices.pp_minim * 100).toFixed(2)
        obj['discount'] = parseFloat(-(obj.price - data.product.prices['pp_amanunt']) / data.product.prices['pp_amanunt'] * 100).toFixed(2)

        this.offer_rows['products'].push(obj)
        product['stoc'] = product['stoc'] - product['qty']
        product['qty'] = 1
        this.$notify({
          group: 'succes',
          type: 'success',
          // title: 'Added',
          text: 'Produsul a fost adaugat in oferta',
          'animation-type': 'css'
        })
      }
      this.scrollToLastProduct(data, 'offer-table-wrapper')
    },
    removeItem (index, collection) {
      this.offer_rows[collection].splice(index, 1)
    },
    async saveOffer (param) {
      if (!this.select_client) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.selectClient'),
          'animation-type': 'css'
        })
        return false
      }
      let validatorResp = true
      await this.$refs.clientCompRef.$validator.validateAll().then((result) => {
        validatorResp = result
        if (this.$refs.clientCompRef.$validator.errors && !result) {
          this.$refs.clientCompRef.select_client_form_status = true
          this.$refs.clientCompRef.checked = false
          let input = document.getElementById(this.$validator.errors.items[0].field)
          window.scrollTo(0, input.offsetTop - 50)
        }
      })
      if (!validatorResp) {
        return
      }

      if (this.offer_rows.products.length === 0) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.ofertaGoala'),
          'animation-type': 'css'
        })
        return false
      }
      let data = {
        generate: (param) || null,
        client: this.select_client,
        client_id: this.select_client.id,
        offer_template_id: (this.select_offer_template) ? this.select_offer_template.id : null,
        template_content: this.offer_description,
        products: this.offer_rows.products,
        services: this.offer_rows.services,
        post_services: this.offer_rows.post_services,
        discount: this.discount,
        objective: this.objective,
        representative_products: this.representative_products,
        validity_date: this.validity_date,
        showTotalDiscount: this.totalDiscountCheckbox,
        totalDiscount: this.discountTotal()
      }
      if (this.select_partner) {
        data['partner_id'] = this.select_partner.id
      }

      if (this.select_client.email === '' && param === 3) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: 'Clientul selectat nu are o adresa de email setata',
          'animation-type': 'css'
        })
        return false
      }

      this.$store.dispatch('showLoading')
      // this.adjustLoadingContainer()
      OffersService.create(data)
        .then((response) => {
          this.updateClientLocalforage(this.select_client)
          this.$store.dispatch('hideLoading')
          this.$notify({
            group: 'succes',
            type: 'success',
            // title: 'Added',
            text: this.$t('success.ofertaSalvata'),
            'animation-type': 'css'
          })
          if (param === 3) {
            OffersService
              .sendOffer({ id: response.data.data.id })
              .then((response) => {
                this.$store.dispatch('hideLoading')
                this.$notify({
                  group: 'succes',
                  type: 'success',
                  // title: 'Added',
                  text: this.$t('success.ofertaTrimisa'),
                  'animation-type': 'css'
                })
                this.$router.push('/offers')
              }).catch((error) => {
                this.$store.dispatch('hideLoading')
                this.$notify({
                  group: 'error',
                  type: 'error',
                  title: this.$t('errors.errorTitle'),
                  text: error.response.data.error,
                  'animation-type': 'css'
                })
              })
          }
          localforage.removeItem('pending_offer').then((respones) => {
            this.$router.push('/offers')
            if (param) {
              this.downloadResource(process.env.VUE_APP_API_ENDPOINT + '/export/offer-pdf/' + response.data.data.id)
            }
          })
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            let errors = Object.entries(error.response.data.error)
            let msgError = ''
            for (const [key, msg] of errors) {
              console.log(key)
              msgError += '<br>' + msg
            }
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: msgError,
              'animation-type': 'css'
            })
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
          this.closeSlideout()
        })
    },
    previewOffer () {
      if (!this.select_client) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.selectClient'),
          'animation-type': 'css'
        })
        return false
      }
      if (this.offer_rows.products.length === 0 && this.offer_rows.services.length === 0 && this.offer_rows.post_services.length === 0) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.ofertaGoala'),
          'animation-type': 'css'
        })
        return false
      }
      let data = {
        client: this.select_client.id,
        offer_template_id: (this.select_offer_template) ? this.select_offer_template.id : null,
        template_content: this.offer_description,
        products: this.offer_rows.products,
        services: this.offer_rows.services,
        post_services: this.offer_rows.post_services,
        discount: this.discount
      }
      this.$store.dispatch('showLoading')
      // this.adjustLoadingContainer()
      OffersService.previewOffer(data)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          // this.$router.push(response.data.data)
          this.previewPdf = response.data.data
          this.$refs['preview-modal'].show()
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            let errors = Object.entries(error.response.data.error)
            let msgError = ''
            for (const [key, msg] of errors) {
              console.log(key)
              msgError += '<br>' + msg
            }
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: msgError,
              'animation-type': 'css'
            })
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    }
  },
  async created () {
    this.$store.dispatch('hideLoading')
    this.priceCategoryes = ProductsService.getPriceCategories()
    if (!this.$can(['view addition'])) {
      this.hideAddition = false
    }
    this.getOfferTemplates()
    this.checkLogo()
    this.userWarehouses = this.$store.getters.user.warehouses
    let vm = this
    await localforage.getItem('pending_offer').then((pendingOffer) => {
      if (pendingOffer) {
        if (pendingOffer.offer_rows !== undefined) vm.offer_rows = pendingOffer.offer_rows
        if (pendingOffer.objective !== undefined) vm.objective = pendingOffer.objective
        if (pendingOffer.representative_products !== undefined) vm.representative_products = pendingOffer.representative_products
        if (pendingOffer.validity_date !== undefined) vm.validity_date = pendingOffer.validity_date
      }
    })
    this.$refs.clientCompRef.source = 'offer'
  },

  computed: {
    additional_fields () {
      return [
        {
          inputName: 'new_email',
          labelName: this.$t('placeholder.email'),
          inputValue: (this.select_client) ? this.select_client.email : '',
          icon: 'fas fa-envelope',
          validationRules: 'email'
        }
      ]
    },
    start_page_products () {
      if (this.meta_products.last_page > 5 && this.meta_products.current_page > 2) {
        return parseInt(this.meta_products.current_page, 10) - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page_products () {
      if (this.meta_products.last_page > 5 && this.meta_products.current_page + 2 < this.meta_products.last_page) {
        return parseInt(this.meta_products.current_page, 10) + 2
      } else {
        return this.meta_products.last_page
      }
    },
    // return only 5 pages for pagination
    products_pagination () {
      let pages = []
      for (let i = this.start_page_products; i <= this.stop_page_products; i++) {
        pages.push(i)
      }
      return pages
    },

    start_page_services () {
      if (this.meta_services.last_page > 5 && this.meta_services.current_page > 2) {
        return parseInt(this.meta_services.current_page, 10) - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page_services () {
      if (this.meta_services.last_page > 5 && this.meta_services.current_page + 2 < this.meta_services.last_page) {
        return parseInt(this.meta_services.current_page, 10) + 2
      } else {
        return this.meta_services.last_page
      }
    },
    // return only 5 pages for pagination
    services_pagination () {
      let pages = []
      for (let i = this.start_page_services; i <= this.stop_page_services; i++) {
        pages.push(i)
      }
      return pages
    },

    start_page_post_service () {
      if (this.meta_post_services.last_page > 5 && this.meta_post_services.current_page > 2) {
        return parseInt(this.meta_post_services.current_page, 10) - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page_post_service () {
      if (this.meta_post_services.last_page > 5 && this.meta_post_services.current_page + 2 < this.meta_post_services.last_page) {
        return parseInt(this.meta_post_services.current_page, 10) + 2
      } else {
        return this.meta_post_services.last_page
      }
    },
    // return only 5 pages for pagination
    post_service_pagination () {
      let pages = []
      for (let i = this.start_page_post_service; i <= this.stop_page_post_service; i++) {
        pages.push(i)
      }
      return pages
    },
    addition () {
      let totalMin = 0
      this.offer_rows.products.forEach(function (element) {
        totalMin += parseFloat(element.prices.pp_minim).toFixed(2) * parseInt(element.qty)
      })
      let addition = []
      addition['value'] = (parseFloat(this.total).toFixed(4) - parseFloat(totalMin).toFixed(4)) / 1.19
      addition['percentage'] = ((100 * parseFloat(addition['value']).toFixed(2)) / parseFloat(totalMin / 1.19).toFixed(2)) || 0
      return addition
    },
    subtotal () {
      let subtotal = 0
      this.offer_rows.products.forEach(function (element) {
        subtotal += element.price * element.qty
      })
      return subtotal
    },

    total () {
      let total = this.subtotal
      let discount = this.discount
      if (discount < 0) {
        discount = 0
      }
      if (discount > 100) {
        discount = 100
      }
      if (discount > 0) {
        total = total - discount / 100 * total
      }
      return total
    }
  }
}
</script>
